module.exports = __webpack_public_path__ + "media/images/speech-bubble-63123d511389dd47d297d8023a61dc23.svg";